function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "XMLID_286_"
}, /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_284_",
  fill: "#231F20",
  cx: 7.148,
  cy: -22.863,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_283_",
  fill: "#231F20",
  cx: 35.424,
  cy: -22.863,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_282_",
  fill: "#231F20",
  cx: 63.701,
  cy: -22.863,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_281_",
  fill: "#231F20",
  cx: 91.977,
  cy: -22.863,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_280_",
  fill: "#231F20",
  cx: 120.253,
  cy: -22.863,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_279_",
  fill: "#231F20",
  cx: 148.529,
  cy: -22.863,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_278_",
  fill: "#231F20",
  cx: 176.806,
  cy: -22.863,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_277_",
  fill: "#231F20",
  cx: 205.082,
  cy: -22.863,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_276_",
  fill: "#231F20",
  cx: 233.358,
  cy: -22.863,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_275_",
  fill: "#231F20",
  cx: 261.635,
  cy: -22.863,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_274_",
  fill: "#231F20",
  cx: 289.911,
  cy: -22.863,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_273_",
  fill: "#231F20",
  cx: 318.187,
  cy: -22.863,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_272_",
  fill: "#231F20",
  cx: 346.463,
  cy: -22.863,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_271_",
  fill: "#231F20",
  cx: 374.74,
  cy: -22.863,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_270_",
  fill: "#231F20",
  cx: 403.016,
  cy: -22.863,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_269_",
  fill: "#231F20",
  cx: 431.292,
  cy: -22.863,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_268_",
  fill: "#231F20",
  cx: 459.568,
  cy: -22.863,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_267_",
  fill: "#231F20",
  cx: 487.845,
  cy: -22.863,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_266_",
  fill: "#231F20",
  cx: 516.121,
  cy: -22.863,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_265_",
  fill: "#231F20",
  cx: 544.396,
  cy: -22.863,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_264_",
  fill: "#231F20",
  cx: 572.674,
  cy: -22.863,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_263_",
  fill: "#231F20",
  cx: 600.949,
  cy: -22.863,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_262_",
  fill: "#231F20",
  cx: 629.226,
  cy: -22.863,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_261_",
  fill: "#231F20",
  cx: 657.502,
  cy: -22.863,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_260_",
  fill: "#231F20",
  cx: 685.778,
  cy: -22.863,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_259_",
  fill: "#231F20",
  cx: 714.054,
  cy: -22.863,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_258_",
  fill: "#231F20",
  cx: 742.331,
  cy: -22.863,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_257_",
  fill: "#231F20",
  cx: 770.607,
  cy: -22.863,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_244_",
  fill: "#231F20",
  cx: 7.148,
  cy: 5.413,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_243_",
  fill: "#231F20",
  cx: 35.424,
  cy: 5.413,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_242_",
  fill: "#231F20",
  cx: 63.701,
  cy: 5.413,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_241_",
  fill: "#231F20",
  cx: 91.977,
  cy: 5.413,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_240_",
  fill: "#231F20",
  cx: 120.253,
  cy: 5.413,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_239_",
  fill: "#231F20",
  cx: 148.529,
  cy: 5.413,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_238_",
  fill: "#231F20",
  cx: 176.806,
  cy: 5.413,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_237_",
  fill: "#231F20",
  cx: 205.082,
  cy: 5.413,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_236_",
  fill: "#231F20",
  cx: 233.358,
  cy: 5.413,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_235_",
  fill: "#231F20",
  cx: 261.635,
  cy: 5.413,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_234_",
  fill: "#231F20",
  cx: 289.911,
  cy: 5.413,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_233_",
  fill: "#231F20",
  cx: 318.187,
  cy: 5.413,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_232_",
  fill: "#231F20",
  cx: 346.463,
  cy: 5.413,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_231_",
  fill: "#231F20",
  cx: 374.74,
  cy: 5.413,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_230_",
  fill: "#231F20",
  cx: 403.016,
  cy: 5.413,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_229_",
  fill: "#231F20",
  cx: 431.292,
  cy: 5.413,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_228_",
  fill: "#231F20",
  cx: 459.568,
  cy: 5.413,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_227_",
  fill: "#231F20",
  cx: 487.845,
  cy: 5.413,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_226_",
  fill: "#231F20",
  cx: 516.121,
  cy: 5.413,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_225_",
  fill: "#231F20",
  cx: 544.396,
  cy: 5.413,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_224_",
  fill: "#231F20",
  cx: 572.674,
  cy: 5.413,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_223_",
  fill: "#231F20",
  cx: 600.949,
  cy: 5.413,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_222_",
  fill: "#231F20",
  cx: 629.226,
  cy: 5.413,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_221_",
  fill: "#231F20",
  cx: 657.502,
  cy: 5.413,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_220_",
  fill: "#231F20",
  cx: 685.778,
  cy: 5.413,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_219_",
  fill: "#231F20",
  cx: 714.054,
  cy: 5.413,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_218_",
  fill: "#231F20",
  cx: 742.331,
  cy: 5.413,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_217_",
  fill: "#231F20",
  cx: 770.607,
  cy: 5.413,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_204_",
  fill: "#231F20",
  cx: 7.148,
  cy: 33.689,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_203_",
  fill: "#231F20",
  cx: 35.424,
  cy: 33.689,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_202_",
  fill: "#231F20",
  cx: 63.701,
  cy: 33.689,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_201_",
  fill: "#231F20",
  cx: 91.977,
  cy: 33.689,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_200_",
  fill: "#231F20",
  cx: 120.253,
  cy: 33.689,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_199_",
  fill: "#231F20",
  cx: 148.529,
  cy: 33.689,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_198_",
  fill: "#231F20",
  cx: 176.806,
  cy: 33.689,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_197_",
  fill: "#231F20",
  cx: 205.082,
  cy: 33.689,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_196_",
  fill: "#231F20",
  cx: 233.358,
  cy: 33.689,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_195_",
  fill: "#231F20",
  cx: 261.635,
  cy: 33.689,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_194_",
  fill: "#231F20",
  cx: 289.911,
  cy: 33.689,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_193_",
  fill: "#231F20",
  cx: 318.187,
  cy: 33.689,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_192_",
  fill: "#231F20",
  cx: 346.463,
  cy: 33.689,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_191_",
  fill: "#231F20",
  cx: 374.74,
  cy: 33.689,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_190_",
  fill: "#231F20",
  cx: 403.016,
  cy: 33.689,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_189_",
  fill: "#231F20",
  cx: 431.292,
  cy: 33.689,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_188_",
  fill: "#231F20",
  cx: 459.568,
  cy: 33.689,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_187_",
  fill: "#231F20",
  cx: 487.845,
  cy: 33.689,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_186_",
  fill: "#231F20",
  cx: 516.121,
  cy: 33.689,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_185_",
  fill: "#231F20",
  cx: 544.396,
  cy: 33.689,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_184_",
  fill: "#231F20",
  cx: 572.674,
  cy: 33.689,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_183_",
  fill: "#231F20",
  cx: 600.949,
  cy: 33.689,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_182_",
  fill: "#231F20",
  cx: 629.226,
  cy: 33.689,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_181_",
  fill: "#231F20",
  cx: 657.502,
  cy: 33.689,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_180_",
  fill: "#231F20",
  cx: 685.778,
  cy: 33.689,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_179_",
  fill: "#231F20",
  cx: 714.054,
  cy: 33.689,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_178_",
  fill: "#231F20",
  cx: 742.331,
  cy: 33.689,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_177_",
  fill: "#231F20",
  cx: 770.607,
  cy: 33.689,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_164_",
  fill: "#231F20",
  cx: 7.148,
  cy: 61.966,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_163_",
  fill: "#231F20",
  cx: 35.424,
  cy: 61.966,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_162_",
  fill: "#231F20",
  cx: 63.701,
  cy: 61.966,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_161_",
  fill: "#231F20",
  cx: 91.977,
  cy: 61.966,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_160_",
  fill: "#231F20",
  cx: 120.253,
  cy: 61.966,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_159_",
  fill: "#231F20",
  cx: 148.529,
  cy: 61.966,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_158_",
  fill: "#231F20",
  cx: 176.806,
  cy: 61.966,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_157_",
  fill: "#231F20",
  cx: 205.082,
  cy: 61.966,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_156_",
  fill: "#231F20",
  cx: 233.358,
  cy: 61.966,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_155_",
  fill: "#231F20",
  cx: 261.635,
  cy: 61.966,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_154_",
  fill: "#231F20",
  cx: 289.911,
  cy: 61.966,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_153_",
  fill: "#231F20",
  cx: 318.187,
  cy: 61.966,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_152_",
  fill: "#231F20",
  cx: 346.463,
  cy: 61.966,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_151_",
  fill: "#231F20",
  cx: 374.74,
  cy: 61.966,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_150_",
  fill: "#231F20",
  cx: 403.016,
  cy: 61.966,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_149_",
  fill: "#231F20",
  cx: 431.292,
  cy: 61.966,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_148_",
  fill: "#231F20",
  cx: 459.568,
  cy: 61.966,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_147_",
  fill: "#231F20",
  cx: 487.845,
  cy: 61.966,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_146_",
  fill: "#231F20",
  cx: 516.121,
  cy: 61.966,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_145_",
  fill: "#231F20",
  cx: 544.396,
  cy: 61.966,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_144_",
  fill: "#231F20",
  cx: 572.674,
  cy: 61.966,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_143_",
  fill: "#231F20",
  cx: 600.949,
  cy: 61.966,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_142_",
  fill: "#231F20",
  cx: 629.226,
  cy: 61.966,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_141_",
  fill: "#231F20",
  cx: 657.502,
  cy: 61.966,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_140_",
  fill: "#231F20",
  cx: 685.778,
  cy: 61.966,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_139_",
  fill: "#231F20",
  cx: 714.054,
  cy: 61.966,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_138_",
  fill: "#231F20",
  cx: 742.331,
  cy: 61.966,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_137_",
  fill: "#231F20",
  cx: 770.607,
  cy: 61.966,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_124_",
  fill: "#231F20",
  cx: 7.148,
  cy: 90.241,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_123_",
  fill: "#231F20",
  cx: 35.424,
  cy: 90.241,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_122_",
  fill: "#231F20",
  cx: 63.701,
  cy: 90.241,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_121_",
  fill: "#231F20",
  cx: 91.977,
  cy: 90.241,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_120_",
  fill: "#231F20",
  cx: 120.253,
  cy: 90.241,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_119_",
  fill: "#231F20",
  cx: 148.529,
  cy: 90.241,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_118_",
  fill: "#231F20",
  cx: 176.806,
  cy: 90.241,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_117_",
  fill: "#231F20",
  cx: 205.082,
  cy: 90.241,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_116_",
  fill: "#231F20",
  cx: 233.358,
  cy: 90.241,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_115_",
  fill: "#231F20",
  cx: 261.635,
  cy: 90.241,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_114_",
  fill: "#231F20",
  cx: 289.911,
  cy: 90.241,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_113_",
  fill: "#231F20",
  cx: 318.187,
  cy: 90.241,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_112_",
  fill: "#231F20",
  cx: 346.463,
  cy: 90.241,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_111_",
  fill: "#231F20",
  cx: 374.74,
  cy: 90.241,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_110_",
  fill: "#231F20",
  cx: 403.016,
  cy: 90.241,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_109_",
  fill: "#231F20",
  cx: 431.292,
  cy: 90.241,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_108_",
  fill: "#231F20",
  cx: 459.568,
  cy: 90.241,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_107_",
  fill: "#231F20",
  cx: 487.845,
  cy: 90.241,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_106_",
  fill: "#231F20",
  cx: 516.121,
  cy: 90.241,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_105_",
  fill: "#231F20",
  cx: 544.396,
  cy: 90.241,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_104_",
  fill: "#231F20",
  cx: 572.674,
  cy: 90.241,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_103_",
  fill: "#231F20",
  cx: 600.949,
  cy: 90.241,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_102_",
  fill: "#231F20",
  cx: 629.226,
  cy: 90.241,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_101_",
  fill: "#231F20",
  cx: 657.502,
  cy: 90.241,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_100_",
  fill: "#231F20",
  cx: 685.778,
  cy: 90.241,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_99_",
  fill: "#231F20",
  cx: 714.054,
  cy: 90.241,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_98_",
  fill: "#231F20",
  cx: 742.331,
  cy: 90.241,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_97_",
  fill: "#231F20",
  cx: 770.607,
  cy: 90.241,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_84_",
  fill: "#231F20",
  cx: 7.148,
  cy: 118.519,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_83_",
  fill: "#231F20",
  cx: 35.424,
  cy: 118.519,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_82_",
  fill: "#231F20",
  cx: 63.701,
  cy: 118.519,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_81_",
  fill: "#231F20",
  cx: 91.977,
  cy: 118.519,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_80_",
  fill: "#231F20",
  cx: 120.253,
  cy: 118.519,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_79_",
  fill: "#231F20",
  cx: 148.529,
  cy: 118.519,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_78_",
  fill: "#231F20",
  cx: 176.806,
  cy: 118.519,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_77_",
  fill: "#231F20",
  cx: 205.082,
  cy: 118.519,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_76_",
  fill: "#231F20",
  cx: 233.358,
  cy: 118.519,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_75_",
  fill: "#231F20",
  cx: 261.635,
  cy: 118.519,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_74_",
  fill: "#231F20",
  cx: 289.911,
  cy: 118.519,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_73_",
  fill: "#231F20",
  cx: 318.187,
  cy: 118.519,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_72_",
  fill: "#231F20",
  cx: 346.463,
  cy: 118.519,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_71_",
  fill: "#231F20",
  cx: 374.74,
  cy: 118.519,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_70_",
  fill: "#231F20",
  cx: 403.016,
  cy: 118.519,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_69_",
  fill: "#231F20",
  cx: 431.292,
  cy: 118.519,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_68_",
  fill: "#231F20",
  cx: 459.568,
  cy: 118.519,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_67_",
  fill: "#231F20",
  cx: 487.845,
  cy: 118.519,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_66_",
  fill: "#231F20",
  cx: 516.121,
  cy: 118.519,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_65_",
  fill: "#231F20",
  cx: 544.396,
  cy: 118.519,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_64_",
  fill: "#231F20",
  cx: 572.674,
  cy: 118.519,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_63_",
  fill: "#231F20",
  cx: 600.949,
  cy: 118.519,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_62_",
  fill: "#231F20",
  cx: 629.226,
  cy: 118.519,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_61_",
  fill: "#231F20",
  cx: 657.502,
  cy: 118.519,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_60_",
  fill: "#231F20",
  cx: 685.778,
  cy: 118.519,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_59_",
  fill: "#231F20",
  cx: 714.054,
  cy: 118.519,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_58_",
  fill: "#231F20",
  cx: 742.331,
  cy: 118.519,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_57_",
  fill: "#231F20",
  cx: 770.607,
  cy: 118.519,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_44_",
  fill: "#231F20",
  cx: 7.148,
  cy: 146.794,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_43_",
  fill: "#231F20",
  cx: 35.424,
  cy: 146.794,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_42_",
  fill: "#231F20",
  cx: 63.701,
  cy: 146.794,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_41_",
  fill: "#231F20",
  cx: 91.977,
  cy: 146.794,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_40_",
  fill: "#231F20",
  cx: 120.253,
  cy: 146.794,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_39_",
  fill: "#231F20",
  cx: 148.529,
  cy: 146.794,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_38_",
  fill: "#231F20",
  cx: 176.806,
  cy: 146.794,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_37_",
  fill: "#231F20",
  cx: 205.082,
  cy: 146.794,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_36_",
  fill: "#231F20",
  cx: 233.358,
  cy: 146.794,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_35_",
  fill: "#231F20",
  cx: 261.635,
  cy: 146.794,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_34_",
  fill: "#231F20",
  cx: 289.911,
  cy: 146.794,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_33_",
  fill: "#231F20",
  cx: 318.187,
  cy: 146.794,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_32_",
  fill: "#231F20",
  cx: 346.463,
  cy: 146.794,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_31_",
  fill: "#231F20",
  cx: 374.74,
  cy: 146.794,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_30_",
  fill: "#231F20",
  cx: 403.016,
  cy: 146.794,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_29_",
  fill: "#231F20",
  cx: 431.292,
  cy: 146.794,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_28_",
  fill: "#231F20",
  cx: 459.568,
  cy: 146.794,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_27_",
  fill: "#231F20",
  cx: 487.845,
  cy: 146.794,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_26_",
  fill: "#231F20",
  cx: 516.121,
  cy: 146.794,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_25_",
  fill: "#231F20",
  cx: 544.396,
  cy: 146.794,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_24_",
  fill: "#231F20",
  cx: 572.674,
  cy: 146.794,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_23_",
  fill: "#231F20",
  cx: 600.949,
  cy: 146.794,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_22_",
  fill: "#231F20",
  cx: 629.226,
  cy: 146.794,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_21_",
  fill: "#231F20",
  cx: 657.502,
  cy: 146.794,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_20_",
  fill: "#231F20",
  cx: 685.778,
  cy: 146.794,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_19_",
  fill: "#231F20",
  cx: 714.054,
  cy: 146.794,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_18_",
  fill: "#231F20",
  cx: 742.331,
  cy: 146.794,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_17_",
  fill: "#231F20",
  cx: 770.607,
  cy: 146.794,
  r: 4.155
}));

function SvgKatakanaProject({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "750px",
    height: "137px",
    viewBox: "0 0 750 137",
    enableBackground: "new 0 0 750 137",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKatakanaProject);
export default __webpack_public_path__ + "static/media/katakana-project.4313cafe.svg";
export { ForwardRef as ReactComponent };